import { useState } from "react";
import { FilterActions } from "./FilterActions.tsx";

export type DateRangeFilterValue = {
  from?: string;
  to?: string;
  onlyMissing?: boolean;
};

const dateInputClassName =
  "w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-700 disabled:bg-gray-50 disabled:text-gray-400";

export function DateRangeFilter({
  value,
  missingLabel,
  onApply,
  close,
}: {
  value: DateRangeFilterValue;
  missingLabel?: string;
  onApply: (value: DateRangeFilterValue) => void;
  close: () => void;
}) {
  const [draft, setDraft] = useState(value);
  const apply = (next: DateRangeFilterValue) => {
    onApply(next);
    close();
  };

  return (
    <div className="flex flex-col gap-2 px-2">
      <div className="grid grid-cols-2 gap-2">
        <label className="flex flex-col gap-1 text-xs text-gray-500">
          Dal
          <input
            type="date"
            value={draft.from ?? ""}
            max={draft.to}
            disabled={draft.onlyMissing}
            onChange={(e) =>
              setDraft({ ...draft, from: e.target.value || undefined })
            }
            className={dateInputClassName}
          />
        </label>
        <label className="flex flex-col gap-1 text-xs text-gray-500">
          Al
          <input
            type="date"
            value={draft.to ?? ""}
            min={draft.from}
            disabled={draft.onlyMissing}
            onChange={(e) =>
              setDraft({ ...draft, to: e.target.value || undefined })
            }
            className={dateInputClassName}
          />
        </label>
      </div>
      {missingLabel && (
        <label className="flex items-center gap-2 text-sm text-gray-700">
          <input
            type="checkbox"
            checked={!!draft.onlyMissing}
            onChange={(e) => setDraft({ onlyMissing: e.target.checked })}
            className="w-4 h-4 accent-primary"
          />
          {missingLabel}
        </label>
      )}
      <FilterActions
        canClear={!!(value.from || value.to || value.onlyMissing)}
        onClear={() => apply({})}
        onApply={() => apply(draft)}
      />
    </div>
  );
}
